import * as React from "react";
import { dispatch } from "@rematch/core";
import FormModel from "../../viewModel/formModel";
import TradeSource from "./tradeSource";
import TradingStatus from "./tradingStatus";
import TSSecondaryLinkage from "./tsSecondaryLinkage";

const onSelectChange = (e, field, modelName) => {
  let data = {};
  data[field] = e;

  dispatch["antDemo"].setValue({
    formInfo: data,
    model: modelName,
    field,
    value: e
  });
};
// 返回交易来源组件
export const getTradeSource = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <TradeSource
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      //这里的对应redux中的属性(字段)
      data-field={formModel.field}
      // 这里对应城市字段
      tradingStatus-field={formModel.extField1}
    />
  );
};

// 返回交易状态组件
export const getTradingStatus = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <TradingStatus
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      //这里的对应redux中的属性(字段)
      data-field={formModel.field}
      // 这里对应城市字段
      tradingStatus-field={formModel.extField1}
    />
  );
};

export const getTSSecondaryLinkage = (formModel: FormModel) => {
  let tradeSourceForm = new FormModel();
  tradeSourceForm = { ...formModel };
  tradeSourceForm.width = 120;
  tradeSourceForm.field = formModel.field;
  tradeSourceForm.value = formModel.value;
  tradeSourceForm.extField1 = formModel.extField1;

  let tradingStatusForm = new FormModel();
  tradingStatusForm = { ...formModel };
  tradingStatusForm.width = 120;
  tradingStatusForm.field = formModel.extField1;
  tradingStatusForm.value = formModel.extFieldValue1;

  return (
    <TSSecondaryLinkage
      tradeSourceData={tradeSourceForm}
      tradingStatusData={tradingStatusForm}
    />
  );
};
